import { useNavigate } from "react-router-dom";
import { Building2 } from "lucide-react";

interface SharedPropertyCardProps {
  property: {
    id: string;
    name: string;
    address: string | null;
    unit?: string | null;
    property_photo_url: string | null;
  };
  hostLabel: string;
}

/** Slice 25 W9 — Shared with you card. Never teal-owned. */
export const SharedPropertyCard = ({ property, hostLabel }: SharedPropertyCardProps) => {
  const navigate = useNavigate();
  const from = hostLabel.trim() ? `From ${hostLabel.trim()}` : "Shared with you";

  return (
    <button
      type="button"
      onClick={() => navigate(`/properties/${property.id}`)}
      className="w-full overflow-hidden rounded-[18px] border-[1.5px] border-[#e6edf1] border-l-[3px] border-l-[#94a3b8] bg-white text-left transition-colors hover:border-[#94a3b8]"
    >
      <div className="relative h-[104px] w-full bg-[#edf1f4] sm:h-[118px]">
        {property.property_photo_url ? (
          <img src={property.property_photo_url} alt="" className="h-full w-full object-cover" />
        ) : (
          <div className="flex h-full w-full items-center justify-center bg-[repeating-linear-gradient(135deg,#edf1f4_0_8px,#e2e8ed_8px_16px)]">
            <Building2 className="h-10 w-10 text-[#94a3b8]" />
          </div>
        )}
        <div className="absolute left-2.5 top-2.5 rounded-full border-[1.5px] border-[#d7e0e6] bg-white px-[11px] py-[5px] text-[12px] font-bold tracking-[0.4px] text-[#5b6b7a]">
          Shared
        </div>
      </div>
      <div className="flex flex-col gap-1.5 p-[13px_16px_15px]">
        <div className="truncate text-[17px] font-bold tracking-[-0.2px] text-[#0f1720]">{property.name}</div>
        <div className="truncate text-[13px] font-medium text-[#64748b]">
          {property.address || "No address"}
          {property.unit ? ` · Unit ${property.unit}` : ""}
        </div>
        <div className="text-[13px] font-bold text-[#64748b]">{from}</div>
      </div>
    </button>
  );
};
